import "./Common/Keypad.api";
export { KeypadDesktop } from "./Desktop/KeypadDesktop.container";
export { KeypadMobile } from "./Mobile/KeypadMobile.container";
export type KeypadActions =
  | "autoplaybutton.disable"
  | "autoplaybutton.enable"
  | "betbutton.disable"
  | "betbutton.enable"
  | "fullscreen.canvas.activate"
  | "fullscreen.canvas.deactivate"
  | "gamehistory.enabled"
  | "gamehistory.available.set"
  | "gamesettings.set"
  | "gamerules.available.set"
  | "lefthandmode.disable"
  | "lefthandmode.enable"
  | "menubutton.disable"
  | "menubutton.enable"
  | "mute.changerequest"
  | "playforfun.show"
  | "playforfun.hide"
  | "plugin.enabled.set"
  | "quickspin.available.set"
  | "quickspin.changerequest"
  | "quickspin.enabled.set"
  | "quickspin.active.set"
  | "sound.mute"
  | "sound.unmute"
  | "soundbutton.disable"
  | "soundbutton.enable"
  | "spin.idle"
  | "spin.quickstop"
  | "spin.start"
  | "spin.winpresentation"
  | "spinbutton.disable"
  | "spinbutton.enable"
  | "view.changerequest"
  | "volume.changerequest"
  | "volume.set";
